import { GD } from "src/GD";
import { FormParser, type FormParserAppearance, type FormParserSize } from "../FormParser";
import { prepareClientSettings } from "./clientSettingsModel";

export type TFormType = "merchant" | "client" | "channel" | "acquirer" | "project" | "merchant_channel" | "terminal" | "merchant_terminal";

type TBaseFormProps = {
	appearance?: FormParserAppearance;
	size?: FormParserSize;
	target_id: any;
	target_type: TFormType;
	type: "credentials" | "integration" | "common" | "fees" | "project_settings" | "client_settings";
	onComplete?: () => void;
};
export const BaseForm = ({ target_id, target_type, type, onComplete, appearance, size }: TBaseFormProps) => {
	return (
		<FormParser
			key="credentials"
			appearance={appearance}
			size={size}
			onSubmit={(data: any) =>
				GD.REQ_API.request({
					method: "settings/set",
					data: data,
				})
			}
			onRequest={async () => {
				const response = await GD.REQ_API.request({
					method: "settings/get",
					data: {
						target_id: target_id,
						target_type: target_type,
						type: type,
					},
				});
				return type === "client_settings" ? prepareClientSettings(response) : response;
			}}
			onComplete={() => {
				onComplete && onComplete();
			}}
		/>
	);
};
